module.exports = __webpack_public_path__ + "img/energy_quanliucheng.a088b82f.png";